export default "__VITE_ASSET__azRTi4Jn__"